import React, { Component } from "react";
import BsyIconBtn from "../BsyIconBtn";
import BsySLoading from "../BsySLoading";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from "../../utils/Utils";

class NameCorrespondenceSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isloading: true
    }
  }

  componentDidMount() {
    React.axios("/data/virtually_contacts_counter_list", {
      appId: this.props.appId,
    }).then(res => {
      const { list } = res.data;
      const data1 = {
        name: React.language("department"),
        selectName: React.language("widget.dept.clickToSelect1"),
        correspondingName: React.language("corresponding.address.book.dept"),
        iconType: "department",
        icon: "icon-bsy-dept",
        type: "1",
        list: [],
        show: true
      }
      const data2 = {
        name: React.language("member"),
        selectName: React.language("widget.user.clickToSelect1"),
        correspondingName: React.language("corresponding.member"),
        iconType: "member",
        icon: "icon-member-normal",
        type: "2",
        list: [],
        show: true
      }
      const data3 = {
        name: React.language("role"),
        selectName: React.language("select.role"),
        correspondingName: React.language("corresponding.role"),
        iconType: "role",
        icon: "icon-bsy-role",
        type: "3",
        list: [],
        show: true
      }
      const data4 = {
        name: React.language("outsiderGroup"),
        selectName: React.language("select.outsiderGroup"),
        correspondingName: React.language("corresponding.outsiderGroup"),
        iconType: "outsiderGroup",
        icon: "icon-bsy-outsider-group",
        type: "4",
        list: [],
        show: true
      }
      const data5 = {
        name: React.language("outsider.member"),
        selectName: React.language("select.outsider.member"),
        correspondingName: React.language("corresponding.outsider.member"),
        iconType: "outsiderMember",
        icon: "icon-widget-usergroup",
        type: "5",
        list: [],
        show: true
      }
      const data6 = {
        name: React.language("subform.data.load.tip21"),
        iconType: "",
        selectName: "",
        correspondingName: "",
        icon: "icon-bsy-post",
        type: "6",
        list: [],
        show: true
      }
      const data7 = {
        name: React.language("user.relation"),
        iconType: "relation",
        selectName: React.language("select.user.relation"),
        correspondingName: React.language("corresponding.user.relation"),
        icon: "icon-bsy-line-relation",
        type: "7",
        list: [],
        show: true
      }
      list.map(res1 => {
        if (res1.type === "1") {
          data1.list.push(res1)
        } else if (res1.type === "2") {
          data2.list.push(res1)
        } else if (res1.type === "3") {
          data3.list.push(res1)
        } else if (res1.type === "4") {
          data4.list.push(res1)
        } else if (res1.type === "5") {
          data5.list.push(res1)
        } else if (res1.type === "7") {
          data7.list.push(res1)
        }
        return null;
      })
      const newData = [data1, data2, data3, data4, data5, data6, data7];
      this.setState({ data: newData, isloading: false });
    })
  }

  switchShowHide = (item) => {
    return () => {
      const { data } = this.state;
      data.map(res => {
        if (res.type === item.type) {
          res.show = !res.show;
        }
        return null;
      })
      this.setState({ data })
    }
  }

  onSave = () => {
    const { data } = this.state;
    const list = [];
    const dockType = ["dockcorp", "dockdept", "dockrole", "dockuser"]
    data.map(res => {
      res.list.map(res1 => {
        if (res1.counter.length > 0) {
          res1.counter.map(res2 => {
            const mode = res2.mode || res1.dockType;
            if (dockType.indexOf(mode) > -1) {
              list.push({
                _id: res1._id,
                counter_id: res2._id,
                dockType: mode
              })
            } else {
              list.push({
                _id: res1._id,
                counter_id: res2._id
              })
            }
            return null;
          })
        } else {
          list.push({
            _id: res1._id,
            counter_id: ""
          })
        }
        return null;
      })
      return null;
    })
    React.axios("/data/virtually_contacts_counter_update", {
      appId: this.props.appId,
      values: list
    }).then(res => {
      console.log(res)
      const { code } = res.data;
      if (code === 200) {
        tipAlert({
          type: "success",
          msg: React.language("saveInfo.success")
        })
        this.props.slideRef.closeAlter()
      }
    })
  }

  cancelClick = () => {
    this.props.slideRef.closeAlter()
  }

  openSelectCounter = (item, item1) => {
    return () => {
      const _this = this;
      const c = [];
      item1.counter.map(res => {
        c.push(res._id)
        return null;
      })
      const d = new window.FX.ConfirmDialog({
        title: item.selectName,
        height: 576,
        width: 710,
        contentWidget: {
          rowSize: [440],
          colSize: [680],
          padding: 15,
          items: [[{
            widgetName: "memberSelect",
            type: "memberselectpane",

            editable: !0,
            hasMenuType: false,
            radioItem: !0,
            checkEnable: !1,
            radioEnable: !0,
            checkType: "radio",
            memberEnable: item.type === "2",
            departmentEnable: item.type === "1",
            outsiderMemberEnable: item.type === "5",
            outsiderGroupEnable: item.type === "4",
            roleEnable: item.type === "3",
            relationEnable: item.type === "7",
            roleChildEnable: item.type === "3",
            corpEnable: !1,
            dynamicEnable: !1,
            dynamicType: "set",
            appType: window.FX.STATIC.APPTYPE,
            scene: "nameCorrespondenceSetting",
            value: c,
          }]]
        },
        onOk: function () {
          const dept = d.getWidgetByName("memberSelect");
          const d1 = dept.getAllJsonValue();
          React.axios(item.type === "7" ? "/corp/relation/list" : "/corp/list_member_name", { appId: _this.props.appId, members: d1.sortValue }).then(res => {
            const { data } = _this.state;
            const { dockcorp, departments, list, roles, outsiderGroup, users, outsiderMember, dockuser, dockrole, dockdept } = res.data;
            const counter = [];
            if (item.type === "1") {
              departments && counter.push(...departments)
              dockcorp && dockcorp.map(res => res.mode = "dockcorp") && counter.push(...dockcorp)
              dockdept && dockdept.map(res => res.mode = "dockdept") && counter.push(...dockdept)
            } else if (item.type === "2") {
              users && counter.push(...users)
              dockuser && dockuser.map(res => res.mode = "dockuser") && counter.push(...dockuser)
            } else if (item.type === "3") {
              roles && counter.push(...roles)
              dockrole && dockrole.map(res => res.mode = "dockrole") && counter.push(...dockrole)
            } else if (item.type === "4") {
              outsiderGroup && counter.push(...outsiderGroup)
            } else if (item.type === "5") {
              outsiderMember && counter.push(...outsiderMember)
            } else if (item.type === "7") {
              // deptRelation && counter.push(...list);
              counter.push(...(list.filter(res => d1.sortValue.includes(res._id))));
            }
            data.map(res => {
              if (res.type === item.type) {
                res.list.map(res1 => {
                  if (res1._id === item1._id) {
                    res1.counter = counter;
                  }
                  return null;
                })
              }
              return null;
            })
            _this.setState({ data })
          })

          return !1;
        }
      });
      d.show()
    }
  }

  render() {
    const { data, isloading } = this.state;
    return (
      <div className="NameCorrespondenceSetting">
        <div className="correspondenceSettingCont">
          {isloading && <BsySLoading style={{ background: '#ffffff' }}></BsySLoading>}
          <div className="settingBody">
            {
              data.map(res => {
                return res.list.length > 0 && <div className="bodyItem">
                  <div className="itemHeader">
                    <div className="headerLeft">
                      <span>{res.name}</span>
                    </div>
                    <div className="headerRight">
                      <span onClick={this.switchShowHide(res)}>{res.show ? React.language("collect") : React.language("display.show")}</span>
                    </div>
                  </div>
                  <div className="itemBody">
                    {res.show && <div className="bodyList">
                      {
                        res.list.map((res1, index) => {
                          return <div className="listItem" key={`m-${index}`}>
                            <div className="itemHeader">
                              <div className="itemLeft">
                                <span className="headerTitle">{React.language('label.name')}: </span>
                                <span className="headerName" title={res1.name}>{res1.name}</span>
                              </div>
                              <div className="itemRight">
                                <span
                                  className="headerTitle">{res.correspondingName}: </span>
                                <div className="selectCounter">
                                  <div className="counterCont" onClick={this.openSelectCounter(res, res1)}>
                                    {res1.counter.length <= 0 && <span className="counterEmpty">{res.selectName}</span>}
                                    {res1.counter.length > 0 && res1.counter.map(res2 => {
                                      let bg = BsyUtils.formatUserThumb(res2.name || res2.nickname);
                                      return <div className={`select-item ${res.iconType}`}>
                                        {res.iconType === "department" && <i className="select-icon icon-department"></i>}
                                        {(res.iconType === "member" || res.iconType === "outsiderMember") && <>
                                          {
                                            res2 && res2.avatarurl ?
                                              <img className="user-center" alt="" src={res2.avatarurl}></img> :
                                              BsyUtils.isObjectEmpty(bg) ? '' : <span className={'table-user-portrait-name color-' + bg.color} ><span>{bg.name[0]}</span></span>
                                          }
                                        </>}
                                        {res.iconType === "role" && <i className="select-icon icon-role"></i>}
                                        {res.iconType === "outsiderGroup" && <i className="select-icon icon-outsider-group"></i>}
                                        {res.iconType === "relation" && <i className="select-icon icon-bsy-relation"></i>}

                                        {res.iconType === "relation" ? <span className="select-item-name">{(res2.name || res2.nickname)}</span> : res.iconType === "department" ? <span className="select-item-name">{(res2.corpname ? (res2.corpname + " - ") : "") + (res2.name || res2.nickname)}</span> : <span className="select-item-name">{res2.name || res2.nickname}</span>}
                                      </div>
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="itemBody">
                              <span className="bodyRemarkTitle">{React.language('corp.dingtalk.Step4.desc')}: </span>
                              <span className="bodyRemark">{res1.remark}</span>
                            </div>
                          </div>
                        })
                      }
                    </div>}
                  </div>
                </div>
              })
            }
          </div>
          <div className="settingsFooter">
            {
              this.props.autoopen === true ? "" : <BsyIconBtn
                text={React.language('cancel')}
                click={this.cancelClick}
                type="white"
                mode={window.mode}
              />
            }

            <BsyIconBtn
              text={React.language('save')}
              click={this.onSave}
              type="blue"
              mode={window.mode}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default NameCorrespondenceSetting